import { render, staticRenderFns } from "./PxCriterioCategoria.vue?vue&type=template&id=103f8130&"
import script from "./PxCriterioCategoria.vue?vue&type=script&lang=js&"
export * from "./PxCriterioCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports